import React from "react";
import "./BackGround.scss";

const BackGround = () => {
  return (
    <div className="LaunchesBackground">
      <div id="stars"></div>
      <div id="stars2"></div>
      <div id="stars3"></div>
    </div>
  );
};

export default BackGround;
